import { render, staticRenderFns } from "./HistoryListItem.vue?vue&type=template&id=815f0f30&scoped=true&"
import script from "./HistoryListItem.vue?vue&type=script&lang=js&"
export * from "./HistoryListItem.vue?vue&type=script&lang=js&"
import style0 from "./HistoryListItem.vue?vue&type=style&index=0&id=815f0f30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "815f0f30",
  null
  
)

component.options.__file = "HistoryListItem.vue"
export default component.exports